(() => {
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  const initFilters = () => {
    const form = document.querySelector('[data-ff-filters]');
    const toggle = document.querySelector('[data-ff-filter-toggle]');
    if (form && toggle) {
      const narrow = window.matchMedia('(max-width: 749px)');
      if (narrow.matches) form.hidden = true;
      toggle.setAttribute('aria-expanded', String(!form.hidden));
      toggle.addEventListener('click', () => {
        form.hidden = !form.hidden;
        toggle.setAttribute('aria-expanded', String(!form.hidden));
      });
    }
    if (form) {
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]')) form.requestSubmit();
      });
      form.addEventListener('formdata', (event) => {
        form.querySelectorAll('input[type="number"]').forEach((input) => {
          if (input.value === '') event.formData.delete(input.name);
        });
      });
    }
    // Long lists: first 6 values show, the rest behind "Show N more"
    document.querySelectorAll('[data-ff-more]').forEach((group) => {
      const btn = group.querySelector('[data-ff-more-btn]');
      if (!btn) return;
      const label = btn.textContent;
      group.setAttribute('data-ff-collapsed', '');
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const collapsed = group.toggleAttribute('data-ff-collapsed');
        btn.textContent = collapsed ? label : 'Show fewer';
      });
    });
    document.querySelectorAll('[data-ff-sort] select').forEach((select) => {
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    document.querySelectorAll('.ff-util__loc select').forEach((select) => {
      select.addEventListener('change', () => select.form.submit());
    });
  };

  // In stock first. The redirect to the In stock view runs in the <head> (layout/theme.liquid)
  // so no product images start loading twice. These handlers remember when someone clears it,
  // so it stays off for the session.
  const SHOW_ALL_KEY = 'ff_all';
  const store = {
    get: () => { try { return window.sessionStorage.getItem(SHOW_ALL_KEY) === '1'; } catch (e) { return false; } },
    set: (on) => {
      try {
        if (on) window.sessionStorage.setItem(SHOW_ALL_KEY, '1');
        else window.sessionStorage.removeItem(SHOW_ALL_KEY);
      } catch (e) { /* storage blocked */ }
    },
  };

  const initInStock = () => {
    document.querySelectorAll('[data-ff-showall]').forEach((link) => {
      link.addEventListener('click', () => store.set(true));
    });
    document.querySelectorAll('[data-ff-instock-on]').forEach((link) => {
      link.addEventListener('click', () => store.set(false));
    });
    const filters = document.querySelector('[data-ff-filters]');
    if (filters) {
      filters.addEventListener('change', (event) => {
        const input = event.target;
        if (input.name === 'filter.v.availability' && input.value === '1') store.set(!input.checked);
      });
    }
  };

  // Sold-out items go after the last in-stock page. They load as the shopper nears the
  // bottom, a page at a time, from the same collection with the Out of stock filter.
  const initSoldOut = () => {
    const box = document.querySelector('[data-ff-soldout]');
    if (!box) return;
    const grid = box.querySelector('[data-ff-soldout-grid]');
    const more = box.querySelector('[data-ff-soldout-more]');
    let page = 0;
    let busy = false;
    const pageUrl = (n) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('filter.v.availability');
      url.searchParams.append('filter.v.availability', '0');
      url.searchParams.set('section_id', box.dataset.section);
      url.searchParams.set('page', String(n));
      return url.toString();
    };
    const load = () => {
      if (busy) return;
      busy = true;
      more.setAttribute('aria-busy', 'true');
      fetch(pageUrl(page + 1))
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('.ff-grid:not([data-ff-soldout-grid]) > li');
          items.forEach((li) => {
            li.querySelectorAll('img[loading="eager"]').forEach((img) => { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
            grid.append(document.importNode(li, true));
          });
          page += 1;
          const hasNext = [...doc.querySelectorAll('.ff-pager a')].some((a) => a.textContent.trim() === 'Next');
          if (hasNext && items.length) {
            more.textContent = 'Show more sold-out items';
            more.removeAttribute('aria-busy');
          } else {
            more.parentElement.hidden = true;
          }
          busy = false;
        })
        .catch(() => { busy = false; more.removeAttribute('aria-busy'); });
    };
    more.addEventListener('click', (event) => { event.preventDefault(); load(); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    } else {
      load();
    }
  };

  const initProduct = (root) => {
    root.querySelectorAll('[data-ff-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('input');
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.ffQty));
        input.value = next;
      });
    });

    const thumbs = root.querySelectorAll('[data-ff-thumb]');
    const slides = root.querySelectorAll('[data-ff-slide]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.ffThumb;
        slides.forEach((slide) => { slide.hidden = slide.dataset.ffSlide !== index; });
        thumbs.forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
      });
    });

    const dataEl = root.querySelector('[data-ff-variants]');
    const select = root.querySelector('[data-ff-variant-select]');
    if (!dataEl || !select) return;
    const data = JSON.parse(dataEl.textContent);
    const priceWrap = root.querySelector('[data-ff-price-wrap]');
    const stock = root.querySelector('[data-ff-stock]');
    const atc = root.querySelector('[data-ff-atc]');
    const sku = root.querySelector('[data-ff-sku]');

    const barcode = root.querySelector('[data-ff-barcode]');
    const skuRow = root.querySelector('[data-ff-sku-row]');
    const barcodeRow = root.querySelector('[data-ff-barcode-row]');

    select.addEventListener('change', () => {
      const v = data.variants.find((item) => String(item.id) === select.value);
      if (!v) return;
      const box = document.createElement('div');
      box.className = 'ff-pbox';
      const now = document.createElement('div');
      now.className = 'ff-pbox__now';
      now.textContent = v.price;
      const meta = document.createElement('div');
      meta.className = 'ff-pbox__meta';
      if (v.rrp) {
        const rrp = document.createElement('span');
        rrp.append('RRP ');
        const s = document.createElement('s');
        s.textContent = v.rrp;
        rrp.append(s);
        const save = document.createElement('span');
        save.className = 'ff-pbox__save';
        save.textContent = `You save ${v.save} (${v.pct}%)`;
        meta.append(rrp, save);
      }
      if (data.taxesIncluded) {
        const vat = document.createElement('span');
        vat.textContent = 'Price includes VAT';
        meta.append(vat);
      }
      box.append(now, meta);
      priceWrap.replaceChildren(box);

      const line = document.createElement('div');
      if (v.available) {
        line.className = data.preorder ? 'ff-stock ff-stock--pre' : data.leadTime ? 'ff-stock ff-stock--lead' : 'ff-stock';
        let label = 'In stock';
        if (data.leadTime) label = data.leadTime;
        else if (v.tracked && v.stock >= 10) label = '10+ in stock';
        else if (v.tracked && v.stock > 0) label = `Only ${v.stock} left`;
        line.textContent = data.preorder ? 'Pre-order' : label;
        stock.replaceChildren(line);
        if (!data.preorder && data.dispatch) {
          const disp = document.createElement('p');
          disp.className = 'ff-disp';
          disp.textContent = data.dispatch;
          stock.append(disp);
        }
        atc.disabled = false;
        atc.textContent = data.preorder ? 'Pre-order now' : 'Add to basket';
      } else {
        line.className = 'ff-stock ff-stock--out';
        line.textContent = 'Sold out';
        stock.replaceChildren(line);
        atc.disabled = true;
        atc.textContent = 'Sold out';
      }
      if (sku) sku.textContent = v.sku || '';
      if (skuRow) skuRow.hidden = !v.sku;
      if (barcode) barcode.textContent = v.barcode || '';
      if (barcodeRow) barcodeRow.hidden = !v.barcode;
      if (v.media) {
        const target = root.querySelector(`[data-ff-media="${v.media}"]`);
        if (target) {
          slides.forEach((slide) => { slide.hidden = slide !== target; });
          thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.ffThumb === target.dataset.ffSlide)));
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    });
  };

  const setCount = (n) => {
    document.querySelectorAll('.ff-count').forEach((el) => {
      el.textContent = n;
      el.setAttribute('aria-label', `${n} items in basket`);
    });
  };
  const refreshCount = () => {
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => { if (c) setCount(c.item_count); })
      .catch(() => {});
  };
  document.addEventListener('cart:update', (event) => {
    const d = event.detail || {};
    const n = d.data?.itemCount ?? d.resource?.item_count;
    if (typeof n === 'number') setCount(n);
    else refreshCount();
  });
  window.addEventListener('pageshow', (event) => { if (event.persisted) refreshCount(); });

  // Panel tile pictures carry data-ff-src until the panel is first wanted, so they
  // don't compete with the page's own product photos on every load.
  const wakeMega = (item) => {
    item.querySelectorAll('img[data-ff-src]').forEach((img) => {
      if (img.dataset.ffSrcset) img.srcset = img.dataset.ffSrcset;
      img.src = img.dataset.ffSrc;
      img.removeAttribute('data-ff-src');
      img.removeAttribute('data-ff-srcset');
    });
  };
  const initMega = () => {
    document.querySelectorAll('.ff-nav__item--mega').forEach((item) => {
      ['pointerenter', 'focusin'].forEach((type) => item.addEventListener(type, () => wakeMega(item), { once: true }));
      item.addEventListener('mouseleave', () => item.classList.remove('is-closed'));
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        item.classList.add('is-closed');
        item.querySelector('.ff-nav__link')?.focus();
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) item.classList.remove('is-closed');
      });
    });
  };

  ready(() => {
    initMega();
    initFilters();
    initInStock();
    initSoldOut();
    document.querySelectorAll('[data-ff-product]').forEach(initProduct);
  });
})();
